import React from 'react';
import './Layout.css';

const Layout = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen">
      {/* Main Content Area */}
      <main>
        {children}
      </main>
    </div>
  );
};

export default Layout;
